import React from "react";
import { ReactComponent as AllImgSvg } from "../../../assets/images/all_img_svg.svg";

const allTypesOperators = "200";

interface ProviderItem {
  id: string;
  name: string;
  imageUrl: string;
  phone?: string;
  containerClass?: string;
  labelClass?: string;
  alt?: string;
  text?: string;
}

interface ProvidersProps {
  providersArr: ProviderItem[];
  operatorsArr: string[];
  changeSelectedOprators: Function;
  stringsFromServer: {
    site_FilterAll: string;
  };
  browserLanguage: string;
}

interface ProvidersState {
  operatorsOpen: boolean;
}

class ProvidersCheckboxes extends React.Component<
  ProvidersProps,
  ProvidersState
> {
  state: ProvidersState = {
    operatorsOpen: true,
  };

  render() {
    const {
      providersArr,
      operatorsArr,
      changeSelectedOprators,
      stringsFromServer,
      browserLanguage,
    } = this.props;

    const isRtl = browserLanguage === "he" || browserLanguage === "ar";
    const isLtr = browserLanguage === "en" || browserLanguage === "ru";

    let currentIndex = 15;

    return (
      <>
        {this.state.operatorsOpen && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "16px",
              justifyItems: "center",
              direction: isRtl ? "rtl" : "ltr",
            }}
          >
           <div
  role="checkbox"
  aria-checked={operatorsArr.includes(allTypesOperators)}
  aria-labelledby="label-allOperators"
  tabIndex={currentIndex}
  onClick={() =>
    changeSelectedOprators(
      allTypesOperators,
      !operatorsArr.includes(allTypesOperators)
    )
  }
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      changeSelectedOprators(
        allTypesOperators,
        !operatorsArr.includes(allTypesOperators)
      );
    }
  }}
  style={{
    gridColumn: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "4px",
  }}
>
  <input
    type="checkbox"
    id="allOperators"
    name="allOperators"
    value={allTypesOperators}
    checked={operatorsArr.includes(allTypesOperators)}
    onChange={() => {}}
    tabIndex={-1}
    aria-hidden="true"
  />
  <label
    className="type-checkbox-label filter-popup-logo-open"
    htmlFor="allOperators"
    style={{ pointerEvents: "none" }}
  >
    <AllImgSvg />
  </label>
  <div
    id="label-allOperators"
    className="text-image"
    style={{ whiteSpace: "normal", textAlign: "center" }}
  >
    {stringsFromServer.site_FilterAll}
  </div>
</div>

    
            {[...providersArr]
              .sort((a, b) => a.name.localeCompare(b.name))
              .filter((provider) => provider.id !== "allOperators")
              .map((provider) => {
                const actualValue = provider.id;
                const isChecked = operatorsArr.includes(provider.id);
    
                return (
                  <div
                    key={provider.id}
                    role="checkbox"
                    aria-checked={isChecked}
                    aria-labelledby={`label-${provider.id}`}
                    tabIndex={currentIndex}
                    onClick={() =>
                      changeSelectedOprators(actualValue, !isChecked)
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        changeSelectedOprators(actualValue, !isChecked);
                      }
                    }}
                    className={provider.containerClass || "all-checkbox"}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "4px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id={provider.id}
                      name={provider.name}
                      value={actualValue}
                      checked={isChecked}
                      onChange={() => {}}
                      tabIndex={-1}
                      aria-hidden="true"
                    />
                    <label
                      className={(provider.labelClass || "type-checkbox-label") + " filter-popup-logo-open"}
                      htmlFor={provider.id}
                      style={{ pointerEvents: "none" }}
                    >
                      <img
                        src={provider.imageUrl}
                        className="type-checkbox-logo"
                        alt={''}
                      />
                    </label>
                    <div
                      id={`label-${provider.id}`}
                      className="text-image"
                      style={{ whiteSpace: "normal", textAlign: "center" }}
                    >
                      {provider.text || provider.name}
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </>
    );
  }
}
    
export default ProvidersCheckboxes;
